import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["topicField", "toneField", "languageField", "lengthField", "additionalNotesField", "loading", "generateButton", "error", "generationCard"]

  generateContent(event) {
    event.preventDefault()

    // Validate topic field
    if (!this.topicFieldTarget.value.trim()) {
      this.showError("Please enter a newsletter topic")
      return
    }

    this.showLoading()
    this.clearError()

    const formData = new FormData()
    formData.append('topic', this.topicFieldTarget.value)
    formData.append('tone', this.toneFieldTarget.value)
    formData.append('language', this.languageFieldTarget.value)
    formData.append('length', this.lengthFieldTarget.value)
    formData.append('additional_notes', this.additionalNotesFieldTarget.value)

    fetch('/admin/newsletters/generate_ai', {
      method: 'POST',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: formData
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
      return response.text()
    })
    .then(html => {
      // Process turbo stream response
      Turbo.renderStreamMessage(html)
      this.hideLoading()
      
      // Hide the generation card after successful generation
      if (this.hasGenerationCardTarget) {
        this.generationCardTarget.classList.add('d-none')
      }
    })
    .catch(error => {
      console.error('Error generating newsletter:', error)
      this.showError('Failed to generate newsletter. Please try again.')
      this.hideLoading()
    })
  }

  showLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove('d-none')
    }
    if (this.hasGenerateButtonTarget) {
      this.generateButtonTarget.disabled = true
      this.generateButtonTarget.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>Generating...'
    }
  }

  hideLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add('d-none')
    }
    if (this.hasGenerateButtonTarget) {
      this.generateButtonTarget.disabled = false
      this.generateButtonTarget.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon me-2">
          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
          <path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7" />
          <path d="M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3" />
          <path d="M9.7 17l4.6 0" />
        </svg>
        Generate Newsletter Content
      `
    }
  }

  showError(message) {
    if (this.hasErrorTarget) {
      this.errorTarget.innerHTML = `<div class="alert alert-danger">${message}</div>`
    }
  }

  clearError() {
    if (this.hasErrorTarget) {
      this.errorTarget.innerHTML = ''
    }
  }
}
